module.exports = __webpack_public_path__ + "img/face.e21fa2fa.png";